const apiConfig = {
  login: {
    name: 'login',
    urlEndpoint: 'auth/login/otp?',
    httpMethod: 'GET',
    hasQueryProps: true,
    isAuthenticated: false,
    hasNamedProps: true,
    hasMixedProps: false,
    stringifyRequest: true,
  },
  otp: {
    name: 'otp',
    urlEndpoint: 'auth/login/otp',
    httpMethod: 'POST',
    isAuthenticated: false,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  me: {
    name: 'me',
    urlEndpoint: 'employee/me',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 5,
  },
  logout: {
    name: 'logout',
    urlEndpoint: 'auth/logout',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  reasons: {
    name: 'reasons',
    urlEndpoint: 'list/txn-reasons/{accountNumber}?',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  paymentCycles: {
    name: 'paymentCycles',
    urlEndpoint: 'payment-cycles?',
    httpMethod: 'GET',
    hasQueryProps: true,
    isAuthenticated: true,
    hasNamedProps: true,
    hasMixedProps: false,
    stringifyRequest: true,
  },
  transactionSummary: {
    name: 'transactionSummary',
    urlEndpoint: 'transactions/{accountNumber}/summary?',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  transactionsHistory: {
    name: 'transactionsHistory',
    urlEndpoint: 'transactions/{accountNumber}?',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  marketingBanner: {
    name: 'marketingBanner',
    urlEndpoint: 'marketing/banners',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  billPayment: {
    name: 'billPayment',
    urlEndpoint: 'products/list?',
    httpMethod: 'GET',
    hasQueryProps: true,
    isAuthenticated: true,
    hasNamedProps: true,
    hasMixedProps: false,
    stringifyRequest: true,
    version: 2,
  },
  topProducts: {
    name: 'topProducts',
    urlEndpoint: 'products/top',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  favourites: {
    name: 'topProducts',
    urlEndpoint: 'products/top',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  referralValidation: {
    name: 'referralValidation',
    urlEndpoint: 'referral/validatecode?',
    httpMethod: 'GET',
    hasQueryProps: true,
    isAuthenticated: true,
    hasNamedProps: true,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  subProductsOrNominals: {
    name: 'subProductsOrNominals',
    urlEndpoint: 'products/view/{productId}?',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  numberHistory: {
    name: 'numberHistory',
    urlEndpoint: 'bill-payment/number-history/{productPrefix}',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  bpRequest: {
    name: 'bpRequest',
    urlEndpoint: 'bill-payment/request',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  imageUpload: {
    name: 'imageUpload',
    urlEndpoint: 'file',
    httpMethod: 'POST',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  bpConfirm: {
    name: 'bpConfirm',
    urlEndpoint: 'bill-payment/confirm',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  banksEnrolled: {
    name: 'banksEnrolled',
    urlEndpoint: 'employee/beneficiary/list',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  withdrawRequest: {
    name: 'withdrawRequest',
    urlEndpoint: 'withdrawal/request',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  withdrawConfirm: {
    name: 'withdrawConfirm',
    urlEndpoint: 'withdrawal/confirm',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  deletImage: {
    name: 'deletImage',
    urlEndpoint: 'file/{documentId}',
    httpMethod: 'DELETE',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },

  autoDisburseDetails: {
    name: 'autoDisburseDetails',
    urlEndpoint: 'auto-disburse/detail/{employeeId}',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  updateTransaction: {
    name: 'updateTransaction',
    urlEndpoint: 'transactions/{transactionHistoryId}',
    httpMethod: 'PATCH',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: true,
    hasMixedProps: true,
    stringifyRequest: false,
  },

  securityPinSimpleRegistration: {
    name: 'securityPinSimpleRegistration',
    urlEndpoint: 'security-pin/simple-registration',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  securityPinVerify: {
    name: 'securityPinVerify',
    urlEndpoint: 'security-pin/verify',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  securityPinOpen: {
    name: 'securityPinOpen',
    urlEndpoint: 'security-pin',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  securityPinOpenV2: {
    name: 'securityPinOpenV2',
    urlEndpoint: 'security-pin',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  securityPinOpenVerify: {
    name: 'securityPinOpenVerify',
    urlEndpoint: 'security-pin',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  securityPinBiometricV2: {
    name: 'securityPinBiometricV2',
    urlEndpoint: 'security-pin',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  securityPinBiometric: {
    name: 'securityPinBiometric',
    urlEndpoint: 'security-pin/biometric',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  phoneNumberChange: {
    name: 'phoneNumberChange',
    urlEndpoint: 'employee/phone-numbers/change',
    httpMethod: 'PUT',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  phoneNumberChangeConfirm: {
    name: 'phoneNumberChangeConfirm',
    urlEndpoint: 'employee/phone-numbers/change',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  picEmployeeReferralList: {
    name: 'picEmployeeReferralList',
    urlEndpoint: 'referral/influencer/list-employees/{employeeId}',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  employerShareReferral: {
    name: 'employerShareReferral',
    urlEndpoint: 'employee/refer',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  profile: {
    name: 'profile',
    urlEndpoint: 'employee/profile',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  allBanks: {
    name: 'allBanks',
    urlEndpoint: 'list/bank?',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  addBank: {
    name: 'addBank',
    urlEndpoint: 'employee/beneficiary/add',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  addBankV2: {
    name: 'addBankV2',
    urlEndpoint: 'employee/beneficiary/add',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  deleteBank: {
    name: 'deleteBank',
    urlEndpoint: 'employee/beneficiary/delete/{beneficiaryId}',
    httpMethod: 'DELETE',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  phoneNumberList: {
    name: 'phoneNumberList',
    urlEndpoint: 'employee/phone-numbers/list',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  addPhone: {
    name: 'addPhone',
    urlEndpoint: 'employee/phone-numbers/add',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  addPhoneV2: {
    name: 'addPhoneV2',
    urlEndpoint: 'employee/phone-numbers/add',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  deletePhone: {
    name: 'deletePhone',
    urlEndpoint: 'employee/phone-numbers/delete/{phoneNumberId}',
    httpMethod: 'DELETE',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: true,
    stringifyRequest: false,
  },
  salaryInfo: {
    name: 'salaryInfo',
    urlEndpoint: 'salary-profile/info',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  logInfo: {
    name: 'logInfo',
    urlEndpoint: 'employee/amplitude-event-context',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  testTimeOut: {
    name: 'testTimeOut',
    urlEndpoint: 'timeout-test?sync=true&time=1000',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  appUpdate: {
    name: 'appUpdate',
    urlEndpoint: 'app-update',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  fetchRoles: {
    name: 'fetchRoles',
    urlEndpoint: 'department-roles',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  fetchDepartments: {
    name: 'fetchDepartments',
    urlEndpoint: 'department-names',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  pinInvalidAttempts: {
    name: 'pinInvalidAttempts',
    urlEndpoint: 'security-pin/invalid-attempts',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  fetchEarnedReferrals: {
    name: 'fetchEarnedReferrals',
    urlEndpoint: 'referral/earned-referral-points',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  fetchReferralTNC: {
    name: 'fetchReferralTNC',
    urlEndpoint: 'referral/referral-tnc',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  featureFlag: {
    name: 'featureFlag',
    urlEndpoint: 'features',
    httpMethod: 'GET',
    hasQueryProps: false,
    isAuthenticated: true,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
  setOptIn: {
    name: 'setOptIn',
    urlEndpoint: 'update-auto-disburse',
    httpMethod: 'PATCH',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: true,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  userProperties: {
    name: 'userProperties',
    urlEndpoint: 'employee-user',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  updateDepartments: {
    name: 'updateDepartments',
    urlEndpoint: 'update-department-designation',
    httpMethod: 'PATCH',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: true,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  addRemoveFavourites: {
    name: 'addRemoveFavourites',
    urlEndpoint: 'products/favorites',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: true,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  notificationPreferences: {
    name: 'notificationPreferences',
    urlEndpoint: 'notifications/preferences',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  updateNotificationPreferences: {
    name: 'updateNotificationPreferences',
    urlEndpoint: 'notifications/preferences',
    httpMethod: 'PUT',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  markAllNotificationsRead: {
    name: 'markAllNotificationsRead',
    urlEndpoint: 'notifications/mark-all-read',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  markNotificationsRead: {
    name: 'markNotificationsRead',
    urlEndpoint: 'notifications/mark-read',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
  },
  notifications: {
    name: 'notifications',
    urlEndpoint: 'notifications?',
    httpMethod: 'GET',
    isAuthenticated: true,
    hasQueryProps: true,
    hasNamedProps: true,
    hasMixedProps: false,
    stringifyRequest: true,
  },
  shortLink: {
    name: 'shortLink',
    urlEndpoint: 'short-link',
    httpMethod: 'POST',
    isAuthenticated: true,
    hasQueryProps: false,
    hasNamedProps: false,
    hasMixedProps: false,
    stringifyRequest: false,
    version: 2,
  },
};

/**
 *
 * @param {string} name for the api name
 * @param {string} baseUrl for api base URL
 * @returns {string} as concatenated string with base url
 */
apiConfig.getApiUrl = (name: string, baseUrl: string) => baseUrl + apiConfig[name].urlEndpoint;

export default apiConfig;
